var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE1House(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 32h8v8h-8v-8zm28 0h-8v8h8v-8zm12-4.45V63H13V27.58L38 8.85l26 18.7zm-4 2.05L38 13.81 17 29.58V59h17V48h8v11h18V29.6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E1_House.dd649659.svg";
export { SvgE1House as ReactComponent };